import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };
  const navLinks = [{
    label: 'Services',
    id: 'services'
  }, {
    label: 'Why Us',
    id: 'why-us'
  }, {
    label: 'How It Works',
    id: 'how-it-works'
  }, {
    label: 'Testimonials',
    id: 'testimonials'
  }, {
    label: 'Contact',
    id: 'contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`} data-id="element-121">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-122">
        <div className="flex items-center justify-between h-16 md:h-20" data-id="element-123">
          {/* Logo */}
          <button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} className={`text-xl md:text-2xl font-bold transition-colors ${isScrolled ? 'text-[#0E7C86]' : 'text-white'}`} data-id="element-124">
            Bright & Clean Solutions
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-125">
            {navLinks.map(link => <button key={link.id} onClick={() => scrollToSection(link.id)} className={`text-sm font-medium transition-colors hover:text-[#0E7C86] ${isScrolled ? 'text-gray-700' : 'text-white'}`} data-id="element-126">
                {link.label}
              </button>)}
            <button onClick={() => scrollToSection('contact')} className="bg-[#6BBF3B] text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#5aa832] transition-colors" data-id="element-127">
              Get a Free Quote
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={`md:hidden p-2 transition-colors ${isScrolled ? 'text-gray-700' : 'text-white'}`} aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'} aria-expanded={isMobileMenuOpen} data-id="element-128">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-129" /> : <MenuIcon className="w-6 h-6" data-id="element-130" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={`md:hidden absolute top-full left-0 right-0 bg-white shadow-lg transition-all duration-300 overflow-hidden ${isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-131">
        <nav className="flex flex-col p-4 gap-2" data-id="element-132">
          {navLinks.map(link => <button key={link.id} onClick={() => scrollToSection(link.id)} className="text-gray-700 font-medium py-3 px-4 text-left hover:bg-gray-50 rounded-lg transition-colors" data-id="element-133">
              {link.label}
            </button>)}
          <button onClick={() => scrollToSection('contact')} className="bg-[#6BBF3B] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#5aa832] transition-colors mt-2" data-id="element-134">
            Get a Free Quote
          </button>
        </nav>
      </div>
    </header>;
}